var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_1293)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0625,
    y: 0.166992,
    width: 32.6667,
    height: 32.6667,
    rx: 16.3333,
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7631 33.2956V38.3895H3.0918V33.2956C3.0918 26.6285 7.9826 21.1048 14.3729 20.1171H14.3743C15.0434 20.0142 15.7291 19.96 16.4274 19.96C18.916 19.96 21.2473 20.6416 23.2406 21.8309C27.1466 24.1553 29.7631 28.4201 29.7631 33.2956Z",
    fill: "#402E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5442 12.8409C23.5442 16.7719 20.3574 19.9587 16.4264 19.9587C14.8852 19.9587 13.4594 19.4691 12.2937 18.6372C10.4868 17.345 9.30859 15.2307 9.30859 12.8409C9.30859 8.90849 12.4954 5.72168 16.4264 5.72168C17.1748 5.72168 17.8967 5.83713 18.5755 6.05274C21.4563 6.96246 23.5442 9.65825 23.5442 12.8409Z",
    fill: "#402E96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_1293"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0625,
    y: 0.166992,
    width: 32.6667,
    height: 32.6667,
    rx: 16.3333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5b0de617dfe86b8ecf0971e0eafc5917.svg";
export { ForwardRef as ReactComponent };